export default "__VITE_ASSET__D9kc4uIp__";